import React from "react";

export default function Banner() {
  return (
    <section className="page-header">
      <h2>#Add to Cart</h2>
      <p>See Your all Cart Products</p>
    </section>
  );
}